import React, { useEffect } from 'react';
import { Center, Spinner } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';

export const Logout: React.FC = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    // Hard redirect — / is the backend-served marketing landing, not a React
    // Router route.
    window.location.replace('/');
  }, [logout]);

  return (
    <Center h="50vh">
      <Spinner size="lg" color="var(--accent)" />
    </Center>
  );
};
